import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import type { ApiError } from "@/react/config/CustomErrors";
import {
  reactQueryPost,
  reactQueryPut,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export interface PollPayload {
  allow_members_to_view_results: boolean;
  closes_at?: string;
  poll_options: {
    value: string;
  };
  title: string;
}

export interface PollOptionType {
  id: number;
  value: string;
}

export interface PollResults {
  detailed_results?: {
    responses: number;
    percentage: number;
    poll_option_id: number;
  }[];
  total_responses: number;
}

export interface PollResponse {
  allow_members_to_view_results: boolean;
  closes_at?: string;
  community_member_id: number;
  community_member_response_option_id?: number;
  created_at: string;
  id: number;
  poll_options: PollOptionType[];
  results?: PollResults;
  sgid: string;
  status: "draft" | "active" | "inactive" | "closed";
  title: string;
  updated_at: string;
}

export const useCreatePoll = (
  options: UseMutationOptions<PollResponse, ApiError, PollPayload> = {},
) =>
  useMutation(
    poll => reactQueryPost<PollResponse>(internalApi.polls.create(), poll),
    options,
  );

interface EditPollPayload extends PollPayload {
  id: number;
}

export const useEditPoll = (
  options: UseMutationOptions<PollResponse, ApiError, EditPollPayload> = {},
) =>
  useMutation(
    poll => reactQueryPut(internalApi.polls.update(poll.id), poll),
    options,
  );
